import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Alert } from 'reactstrap';

function ErrorAlert({ errorState, errorMessage, resetError }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorState) {
      setTimeout(() => {
        dispatch(resetError());
      }, 5000);
    }
  }, [errorState]);

  return (
    <React.Fragment>
      {errorState ?
        <Alert className='my-2' color="danger"> {errorMessage} </Alert>
        : null}
    </React.Fragment>
  )
}

export default ErrorAlert;
